export const isAgreed = (value: boolean | null) => {
    if (value === true) {
        return "Получены";
    } else if (value === null) {
        return "Не требуется";
    } else {
        return "Ожидаются";
    } 
};